import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    popin: null,
    scrollTop: 0,
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  },
  mutations: {
    openPopin (state, name) {
      state.popin = name
    },
    closePopin (state) {
      state.popin = null
    },
    setScrollTop(state, scrollTop){
      state.scrollTop = scrollTop
    },
    resize(state){
      state.innerWidth = window.innerWidth
      state.innerHeight = window.innerHeight
    }
  },
  actions: {

  },
});
